import { mapActions, mapState } from 'vuex';
export default {
    data: function () {
        return {
            validations: {
                atLeast8: false,
                atLeast1Capital: false,
                atLeast1Number: false,
                atLeast1Symbol: false,
                notMatchedPassword: this.reset ? false : true
            },
            total: 0
        };
    },
    computed: {
        ...mapState({
            passwordSubmitFailed: 'Auth/passwordSubmitFailed'
        })
    },
    methods: {
        ...mapActions({
            compareNewPasswordAgainstExisting: 'Auth/comparePasswords',
            setPasswordConfirmed: 'Auth/setPasswordConfirmed',
            passwordValidated: 'Auth/passwordValidated'
        }),
        isCapital(chr) {
            return /[A-Z]/.test(chr);
        },
        hasAtLeast1Capital(val) {
            return val.split().filter(chr => this.isCapital(chr)).length;
        },
        hasAtLeast1Number(val) {
            return /\d/.test(val);
        },
        hasAtLeast8Characters(val) {
            return val.length >= 8;
        },
        hasAtLeast1Symbol(val) {
            return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?£€]/.test(val)
        },
        getValidationTotal() {
            return Object.keys(this.validations).filter(key => this.validations[key] == true).length
        }

    },
    watch: {
        password: async function (val) {
            this.$set(this.validations, 'atLeast8', this.hasAtLeast8Characters(val));
            this.$set(this.validations, 'atLeast1Capital', this.hasAtLeast1Capital(val));
            this.$set(this.validations, 'atLeast1Number', this.hasAtLeast1Number(val));
            this.$set(this.validations, 'atLeast1Symbol', this.hasAtLeast1Symbol(val));

            this.total = this.getValidationTotal();

            if (this.reset) {
                if (this.total >= 4) {
                    try {
                        this.$set(this.validations, 'notMatchedPassword', 'interim');
                        let isMatch = await this.compareNewPasswordAgainstExisting();
                        this.$set(this.validations, 'notMatchedPassword', !isMatch);
                    } catch (err) {
                        this.$set(this.validations, 'notMatchedPassword', false);
                    }

                    if (this.total == 5) {
                        this.passwordValidated(true);
                    } else {
                        this.password_confirmation = '';
                        this.passwordValidated(false);
                    }
                } else {
                    this.notMatchedPassword = false;
                }
            } else {
                if (this.total >= 4) {
                    this.passwordValidated(true);
                } else {
                    this.password_confirmation = '';
                    this.passwordValidated(false);

                }
            }

            if (this.password_confirmation !== '') {
                if (this.password_confirmation == val) {
                    this.setPasswordConfirmed(true);
                } else {
                    this.setPasswordConfirmed(false);
                }
            } else {
                this.setPasswordConfirmed(false);
            }
        },
        password_confirmation: function (val) {
            if (this.password !== '') {
                if (this.password == val) {
                    this.setPasswordConfirmed(true);
                } else {
                    this.setPasswordConfirmed(false);
                }
            } else {
                this.setPasswordConfirmed(false);
            }
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/passwordValid.js